const DocumentFile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='currentColor' {...props}>
    <path
      d='M11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H21C21.5523 16 22 15.5523 22 15C22 14.4477 21.5523 14 21 14H11Z'
      fill='currentColor'
    />
    <path
      d='M10 19C10 18.4477 10.4477 18 11 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H11C10.4477 20 10 19.5523 10 19Z'
      fill='currentColor'
    />
    <path
      d='M10 23C10 22.4477 10.4477 22 11 22H15C15.5523 22 16 22.4477 16 23C16 23.5523 15.5523 24 15 24H11C10.4477 24 10 23.5523 10 23Z'
      fill='currentColor'
    />
    <path
      d='M19 0H8C5.79086 0 4 1.79086 4 4V28C4 30.2091 5.79086 32 8 32H24C26.2091 32 28 30.2091 28 28V9L19 0ZM19 2V6C19 7.65685 20.3431 9 22 9H26V28C26 29.1046 25.1046 30 24 30H8C6.89543 30 6 29.1046 6 28V4C6 2.89543 6.89543 2 8 2H19Z'
      fill='currentColor'
    />
  </svg>
);

export default DocumentFile;
